import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tf-centered-modal__header d-flex justify-content-between align-items-start" }
const _hoisted_2 = { class: "title-4 text-primary-black mb-0 tf-centered-modal__title" }
const _hoisted_3 = { class: "tf-centered-modal__body" }
const _hoisted_4 = {
  key: 0,
  class: "reserve-actions-group"
}
const _hoisted_5 = {
  class: "reserve-action-row__badge reserve-action-row__badge--deposit",
  "aria-hidden": "true"
}
const _hoisted_6 = { class: "reserve-action-row__content" }
const _hoisted_7 = { class: "reserve-action-row__title" }
const _hoisted_8 = {
  key: 0,
  class: "reserve-action-row__amount"
}
const _hoisted_9 = {
  key: 1,
  class: "reserve-actions-group"
}
const _hoisted_10 = {
  key: 0,
  class: "reserve-actions-group__label caption text-grey-700 mb-2"
}
const _hoisted_11 = { class: "reserve-action-list list-unstyled mb-0" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "reserve-action-row__number"
}
const _hoisted_14 = {
  key: 1,
  class: "reserve-action-row__symbol"
}
const _hoisted_15 = { class: "reserve-action-row__content" }
const _hoisted_16 = { class: "reserve-action-row__title" }
const _hoisted_17 = {
  key: 0,
  class: "reserve-action-row__amount"
}
const _hoisted_18 = {
  key: 2,
  class: "reserve-actions-group"
}
const _hoisted_19 = { class: "reserve-action-row__content" }
const _hoisted_20 = { class: "reserve-action-row__title" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import CloseButton from '@/components/UI/CloseButton.vue'
import ChevronRight from '@/assets/ChevronRight.vue'
import ReservationIcon from '@/assets/ReservationIcon.vue'
import type { ReserveAction } from '@/utils/bookingFunnelNavigation'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReserveActionsModal',
  props: {
  actions: {
    type: Array as () => ReserveAction[],
    required: true,
  },
},
  emits: ["select"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const isOpen = ref(false)

const depositAction = computed(() =>
  props.actions.find(action => action.kind === 'options')
)
const paymentActions = computed(() =>
  props.actions.filter(action => action.kind === 'payment')
)
const balanceAction = computed(() =>
  props.actions.find(action => action.kind === 'balance')
)

const open = (): void => {
  isOpen.value = true
  document.body.style.overflow = 'hidden'
}

const close = (): void => {
  isOpen.value = false
  document.body.style.overflow = ''
}

const onSelect = (action: ReserveAction): void => {
  close()
  emit('select', action)
}

__expose({ open, close })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-container" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tf-centered-modal",
              role: "dialog",
              "aria-modal": "true",
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", {
                class: "tf-centered-modal__content",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('reservations.reserveActionsTitle')), 1),
                  _createVNode(CloseButton, { onClose: close })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (depositAction.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "reserve-action-row reserve-action-row--featured",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelect(depositAction.value)))
                        }, [
                          _createElementVNode("span", _hoisted_5, [
                            _createVNode(ReservationIcon, { class: "reserve-action-row__icon" })
                          ]),
                          _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(depositAction.value.title), 1),
                            (depositAction.value.amount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(depositAction.value.amount), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(ChevronRight, { class: "reserve-action-row__chevron" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (paymentActions.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (paymentActions.value.length > 1 || depositAction.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(t)('reservations.reserveActionsPaymentsSection')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("ul", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentActions.value, (action) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: action.id,
                              class: "reserve-action-list__item"
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "reserve-action-row",
                                onClick: ($event: any) => (onSelect(action))
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["reserve-action-row__badge", {
                        'reserve-action-row__badge--numbered':
                          action.instalmentNumber != null,
                      }]),
                                  "aria-hidden": "true"
                                }, [
                                  (action.instalmentNumber != null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(action.instalmentNumber), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "€"))
                                ], 2),
                                _createElementVNode("span", _hoisted_15, [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(action.title), 1),
                                  (action.amount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(action.amount), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(ChevronRight, { class: "reserve-action-row__chevron" })
                              ], 8, _hoisted_12)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (balanceAction.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "reserve-action-row reserve-action-row--balance",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (onSelect(balanceAction.value)))
                        }, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", {
                            class: "reserve-action-row__badge reserve-action-row__badge--balance",
                            "aria-hidden": "true"
                          }, [
                            _createElementVNode("span", { class: "reserve-action-row__symbol" }, "€")
                          ], -1)),
                          _createElementVNode("span", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(balanceAction.value.title), 1)
                          ]),
                          _createVNode(ChevronRight, { class: "reserve-action-row__chevron" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "reserve-actions-cancel link-default w-100 mt-3",
                    onClick: close
                  }, _toDisplayString(_unref(t)('reservations.cancel')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})